import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import NiotaClassicApiService from '@/services/niotaClassicApiService';
import { validImageFileName, readableFileSizeFromBytes as readableFileSizeUtil } from '@/utils/vuex';
import { getFileURL } from '@/utils/file-uploads';
export default {
  name: 'CoreDtwinAttachmentsItem',
  props: {
    source: {
      type: String,
      default: 'digitaltwin'
    },
    item: {
      type: [Object, File],
      required: true
    },
    isQueued: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: true
    },
    selectable: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    isImage: {
      type: Boolean,
      default: false
    },
    apiVersion: {
      type: Number,
      default: 1,
      required: false
    }
  },
  data: function () {
    return {
      messages: {
        error: 'meh meh meh, an occurance has errored.'
      },
      uploadProgress: 0,
      removing: false,
      itemIsSelected: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])
  },
  watch: {
    isSelected() {
      this.itemIsSelected = this.isSelected;
    }
  },
  created() {
    if (this.item.file) {
      this.uploadAttachment(this.item.file);
    }
    this.itemIsSelected = this.isSelected;
  },
  methods: {
    readableFileSizeFromBytes: readableFileSizeUtil,
    getAttachmentDownloadUrl(file) {
      if (this.source === 'devicetype') {
        if (/^http(?:s):\/\//i.test(file.storagePath)) {
          return file.storagePath;
        }
        return `${location.origin}${file.storagePath}`;
      }
      return getFileURL(file.id, this.apiVersion);
    },
    previewAttachment(fileId) {
      this.$emit('item:preview', this.getAttachmentDownloadUrl(fileId));
    },
    isPreviewable(fileName) {
      return validImageFileName(fileName);
    },
    deleteAttachment(file) {
      this.removing = true;
      this.$emit('item:remove', file);
    },
    async uploadAttachment(file) {
      this.formData = new FormData();
      this.formData.append('file', file);
      try {
        let result;
        if (this.source === 'devicetype') {
          result = await NiotaClassicApiService.uploadImage(file, 'devicetype', this.onProgressHandler);
        } else {
          result = await ApiService.saveAttachment(this, this.formData, this.onProgressHandler, this.apiVersion);
        }
        this.$emit('item:update', {
          fileId: result.fileId || result.files[0],
          item: this.item
        });
      } catch (error) {
        console.error(error);
        this.$emit('item:update', null);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('DigitalTwin.DigitalTwin.attachmentErrorUpload'), 'error');
        }
      }
    },
    onProgressHandler(progressEvent) {
      this.uploadProgress = Math.round(progressEvent.loaded / progressEvent.total * 100);
    },
    async downloadAttachment(file) {
      try {
        if (this.source === 'devicetype') {
          // For devicetype source, use the original direct URL approach
          const downloadUrl = this.getAttachmentDownloadUrl(file);
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = file.name;
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          // For other sources, use ApiService.downloadFile
          await ApiService.downloadFile(file.id, file.name, this.apiVersion);
        }
      } catch (error) {
        console.error(error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('DigitalTwin.DigitalTwin.attachmentErrorDownload'), 'error');
        }
      }
    }
  }
};